module.exports = __webpack_public_path__ + "static/38-67411575c2fae054384f104d8e3b9646.png";